import { motion, useReducedMotion } from 'framer-motion';
import cn from '../lib/cn';

/**
 * The waiting state, in two sizes.
 *
 * Both exist because splitting the routes introduced a moment that did not
 * exist before: the gap while a page's chunk arrives. How that gap is filled
 * decides whether code splitting reads as faster or slower.
 *
 * `full` is for the session check, where nothing is on screen yet.
 * `inline` is for a route change, where the shell is already rendered and only
 * the content area is waiting — replacing the whole window there would throw
 * away the part that makes the app feel instant.
 */
export default function PageLoader({ variant = 'inline', label }) {
  const reduceMotion = useReducedMotion();
  const full = variant === 'full';

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        full ? 'min-h-screen' : 'min-h-[45vh]',
      )}
    >
      {/* A spinner is the honest signal here: chunk downloads have no progress
          to report, and a skeleton would promise a shape we do not yet know. */}
      <motion.div
        className="h-8 w-8 rounded border-2 border-separator border-t-blue-500"
        animate={reduceMotion ? undefined : { rotate: 360 }}
        transition={{ duration: 0.9, repeat: Infinity, ease: 'linear' }}
      />
      {label && (
        <p className="font-mono text-caption2 uppercase tracking-wide text-label4">
          {label}
        </p>
      )}
    </div>
  );
}
